<template>
  <div>
    <v-menu
      data-qa="language-menu"
      nudge-bottom="8"
      offset-y
      min-width="260px"
      max-width="260px"
      z-index="9999"
    >
      <template #activator="{ on }">
        <v-btn
          max-width="56"
          min-width="56"
          max-height="32"
          class="change-language-button rounded-xl px-4 py-1"
          :data-qa="`change-language-button-${currentLanguage.iso}`"
          elevation="0"
          color="primary"
          icon
          v-on="on"
        >
          <v-img
            width="24"
            height="16"
            contain
            alt="language-flag"
            :src="currentLanguage.flag_image.url"
          />
        </v-btn>
      </template>
      <div class="p-4">
        <LanguagesList :languages="context.available_languages" />
      </div>
    </v-menu>
  </div>
</template>

<script setup lang="ts">
import LanguagesList from 'src/layouts/core-layout/components/CoreHeader/components/HeaderLanguageToggle/components/LanguagesList.vue'
import type { ContextStore } from 'src/layouts/core-layout/types'
import { useContextStore } from 'src/store'

const { context }: ContextStore = useContextStore()
const currentLanguage = context.current_language
</script>

<style lang="scss">
.change-language-button-mount .v-application--wrap {
  min-height: fit-content !important;
}
</style>
